import moment from 'moment'
import i18n from 'translation/index'
import { openErrorToaster } from 'helpers/toaster.helpers'
import store from 'redux-thunk/store'
import { divide, times } from 'number-precision'

export const DEFAULT_PRECISION_MONEY = 2

export const formatDate = (originalDateString) => {
  const date = new Date(originalDateString)

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const day = date.getDate()
  const monthIndex = date.getMonth()
  const year = date.getFullYear()
  const formattedDate = `${day} ${months[monthIndex]} ${year}`
  return formattedDate
}

export const formatTime = (originalDateString) => {
  const date = new Date(originalDateString)

  const hours = date.getHours()
  const minutes = date.getMinutes()

  const ampm = hours >= 12 ? 'PM' : 'AM'
  const formattedHours = hours % 12 || 12 // Convert 0 to 12 for 12 AM

  const formattedTime = `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`

  return formattedTime
}

/**
 * Parses payload object from jwt
 * @param {string} token
 * @returns {Object}
 */
export const getPayloadFromToken = (token) => {
  if (token) {
    return JSON.parse(atob(token.split('.')[1]))
  }
}


export function generateClientSeed () {
  const availableChars = '0123456789abcdef'
  let seed = ''
  for (let i = 0; i < 32; i++) {
    seed += availableChars[Math.floor(Math.random() * availableChars.length)]
  }
  return seed
}

/**
 *
 * @param {number} value
 * @param {number} precision
 * @returns {number | string} Returns precision value for specified decimal places
 */
export const getPrecision = (value, precision = DEFAULT_PRECISION_MONEY) => {
  const precisionDivide = 10 ** precision
  const result = parseInt(value * precisionDivide) / precisionDivide
  return result || 0
}

// export const getPrecisionVal = (input = 0, precision) => {
//   precision = precision || store?.getState()?.gameSetting?.currencyPrecision
//   if (typeof input === 'number') {
//     const factor = Math.pow(10, precision)
//     input = divide(Math.trunc(times(input, factor)), factor)
//     input = input.toFixed(precision)
//   }

//   const str = String(input)
//   if (str === 'NaN' || str === 'Infinity') {
//     return ''
//   }

//   if (/^[0.]+$/.test(str)) {
//     // Only zeros and decimal
//     return str
//   }

//   // Remove only trailing zeros after decimal
//   return str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '')
// }

// export const getPrecisionVal = (input = 0, precision) => {
//   precision = precision || store?.getState()?.gameSetting?.currencyPrecision || 2

//   if (typeof input === 'number') {
//     const factor = Math.pow(10, precision)
//     input = divide(Math.trunc(times(input, factor)), factor)
//     input = input.toFixed(precision)
//   }

//   const str = String(input)

//   if (str === 'NaN' || str === 'Infinity') return ''

//   if (/^[0.]+$/.test(str)) {
//     // Only zeros and decimal
//     return str
//   }

//   // Remove only trailing zeros after decimal
//   // console.log('str', str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, ''))
//   // return str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '')

//   const [intPart, decimalPart = ''] = str.split('.')

//   if (!decimalPart) return intPart

//   // Trim trailing zeros and limit precision
//   const trimmedNum = decimalPart
//     .slice(0, precision) // limit to precision
//     .replace(/0+$/, '00') // remove trailing zeros

//   return trimmedNum ? `${intPart}.${trimmedNum}` : intPart
// }

export const getPrecisionVal = (value, precision) => {
  // const { precisionValue } = usePrecisionValueController()
  if (typeof value === 'string' && value === '') return ''
  const numericValue = typeof value === 'string' ? Number(value) : value // Parse value if it's a string, safely convert to number

  const precisionVal = precision ?? store?.getState()?.gameSetting?.currencyPrecision ?? 2
  // const state = store.getState()
  // const precisionVal = precisionValue

  if (!Number.isFinite(numericValue)) return typeof value === 'string' ? `0.${'0'.repeat(precisionVal)}` : 0 // Edge case: handle invalid values like NaN, undefined, Infinity safely

  if (typeof value === 'string' && value === '0') return `0.${'0'.repeat(precisionVal)}`

  const precisionDivide = Math.pow(10, precisionVal)
  let result = divide(Math.trunc(times(numericValue, precisionDivide)), precisionDivide)

  if (result.toString().includes('e')) result = result.toFixed(precisionVal)

  return result
}

/**
 * To convert a numeric value to standard precision
 * @param {number} amount amount to be converted to precision
 * @param {number} precision digits to be considered for precision
 * @returns {number}
 */
export const getPrecisionNumber = (amount, precision = DEFAULT_PRECISION_MONEY) => {
  const precisionDivide = 10 ** precision
  const result = (parseInt(amount * precisionDivide) / precisionDivide) || 0
  return result
}

/**
 *
 * @param {number} x
 * @returns {string} valid million based comma value in string
 */
export const numberWithCommas = (x) => {
  if (x === null || x === undefined || Number(x) === Number.isNaN) {
    return ''
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * Get Random Integer from min to max (both inclusive)
 * @param {*} max
 * @returns
 */
export function getRandomInt (min, max) {
  min = Math.ceil(min)
  max = Math.floor(max + 1)
  return Math.floor(Math.random() * (max - min) + min)
}
/**
 * Durstenfeld array shuffling algorithm
 * @param {number} array
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export const copyToClipboard = async (text) => {
  // Modern clipboard API - works in most modern browsers
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      console.warn('Clipboard API copy failed, using fallback.', err)
      return fallbackCopy(text)
    }
  } else {
    // Older browsers or non-HTTPS contexts
    return fallbackCopy(text)
  }
}

const fallbackCopy = (text) => {
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)

  const selection = document.getSelection()
  const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false

  textarea.select()
  try {
    const success = document.execCommand('copy')
    return success
  } catch (err) {
    console.warn('Fallback copy failed.', err)
    return false
  } finally {
    document.body.removeChild(textarea)
    if (selected) {
      selection.removeAllRanges()
      selection.addRange(selected)
    }
  }
}

export const blockInvalidChar = (e) => {
  ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
  if (!/[\d]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
    event.preventDefault()
  }
}

export const blockSpaceChar = e => e.key === ' ' && e.preventDefault()

export const formatDateTime = (dateString) => {
  // Create a new Date object from the given date string
  const date = new Date(dateString)

  // Extract hours, minutes, and determine AM/PM
  let hours = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'

  // Convert 24-hour format to 12-hour format
  hours = hours % 12
  hours = hours || 12 // If hours equals 0, change it to 12

  // Format minutes to be 2 digits
  const minutesFormatted = minutes < 10 ? '0' + minutes : minutes

  // Extract month, day, and year
  const month = date.getUTCMonth() + 1 // Months are zero-indexed
  const day = date.getUTCDate()
  const year = date.getUTCFullYear()

  // Return formatted string
  return `${hours}:${minutesFormatted} ${ampm}  ${month}/${day}/${year}`
}

export const toUtcTime = (dateObject = moment(), dateFormat = 'DD/MM/YYYY') => {
  return moment.utc(dateObject).format(dateFormat)
}

export const showToastToLogin = () => {
  openErrorToaster({ message: i18n.t('LOGIN_REQUIRED') })
}
export const restrictDecimalPlaces = (enteredValue) => {
  const value = String(enteredValue)
  const decimalIndex = value.indexOf('.')

  if (decimalIndex !== -1) {
    // Split into two parts: before the decimal and after the decimal
    const beforeDecimal = value.slice(0, decimalIndex) // Before decimal part
    let afterDecimal = value.slice(decimalIndex + 1) // After decimal part

    // If there are more than two digits after the decimal, replace the second digit
    if (afterDecimal.length > 2) {
      afterDecimal = afterDecimal.slice(0, 1) + afterDecimal.slice(2, 3) // Keep first and third digits after decimal
    }

    // Rebuild the value with the updated decimal part
    const finalValue = beforeDecimal + '.' + afterDecimal
    return +finalValue
  }

  return +value // If there's no decimal point, return the value as is
}
